export const MOBILE_MENU_EVENTS = {
  MOBILE_MENU_OPEN: 'mobile-menu-open',
  MOBILE_MENU_CLOSE: 'mobile-menu-close',
};

export const MOBILE_MENU_USER_PROFILE_EVENTS = {
  LOGOUT: 'logout',
};
